import React, {useEffect, useState} from 'react';
import NavBar from "../../../Component/NavBar/NavBar";
import {IoIosAddCircleOutline} from "react-icons/io";
import apiRequests from "../../../Component/axios/config/config";
import Loading from "../../../Component/Loading/Loading";
import {Link, useNavigate} from "react-router-dom";
import noImage from "../../../font & image/image/noImages.png";
import toast from "react-hot-toast";



export default function Product() {


    const [products, setProducts] = useState([]);
    const [productID, setProductID] = useState("");
    const [name, setName] = useState({
        en: "",
        fa: "",
        fr: "",
        de: "",
        zh: "",
    });
    const [loading, setLoading] = useState(true);
    const [updateProduct, setUpdateProduct] = useState(false);
    const [showModalDelete, setShowModalDelete] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const navigate = useNavigate()

    useEffect(() => {
        fetchProducts(currentPage);
    }, [currentPage, updateProduct, searchQuery]);


    const fetchProducts = (page) => {
        setLoading(true);
        const params = {
            page: page,
            limit: 10,
        };

        if (searchQuery) {
            params.search = searchQuery;
        }

        apiRequests.get(`/api/product/get-all-admin`, {params})
            .then((response) => {
                setProducts(response.data.data.docs);
                setTotalPages(response.data.data.totalPages);
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
                console.error("Failed to fetch products");
            })
            .finally(() => setLoading(false));
    };


    const handleDelete = (id, name) => {
        setShowModalDelete(true);
        setName({...name, en: name})
        setProductID(id)
    };

    const handleEdit = (id) => {
        navigate(`/product/${id}`)
    };

    const handleAdd = () => {
        navigate('/product/create')
    };

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    return (
        <div className="p-6">
            <div className="text-3xl font-bold text-gray-800 mb-6">
                My Product List
            </div>

            <NavBar
                item={[
                    {icon: <IoIosAddCircleOutline/>, title: "Add Product", onClick: handleAdd},
                ]}
                onSearch={(value) => {
                    setSearchQuery(value);
                    setCurrentPage(1);
                }}
            />


            <div className="flex justify-center mt-8">
                <div className="w-full max-w-6xl md:overflow-x-auto">
                    <table className="w-full bg-white shadow-md rounded-lg overflow-hidden">
                        <thead className="bg-gradient-to-r from-green-400 to-blue-500 text-white">
                        <tr>
                            <th className="px-6 py-3 text-left text-sm font-medium text-nowrap">Image</th>
                            <th className="px-6 py-3 text-left text-sm font-medium text-nowrap">Name</th>
                            <th className="px-6 py-3 text-left text-sm font-medium text-nowrap">Category</th>
                            <th className="px-6 py-3 text-left text-sm font-medium text-nowrap">Price</th>
                            <th className="px-6 py-3 text-center text-sm font-medium text-nowrap">Actions</th>
                        </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                        {loading ? (
                            <tr>
                                <td colSpan="5" className="px-6 py-4 text-center">
                                    <Loading/>
                                </td>
                            </tr>
                        ) : products.length > 0 ? (
                            products.map((product) => {
                                    return (
                                        <tr key={product._id} className="hover:bg-gray-100 transition duration-200">
                                            <td className="px-6 py-4 text-nowrap">
                                                <img
                                                    src={product.images ? `https://api.goalafarin.com/${product.images[0]?.path}` : noImage}
                                                    alt={product.name.en}
                                                    className="w-16 h-16 object-cover rounded-lg"
                                                />
                                            </td>
                                            <td className="px-6 py-4 text-gray-800 font-medium text-nowrap"><Link
                                                to={`/product/${product._id}`}> {product.name.en}</Link></td>
                                            <td className="px-6 py-4 text-gray-600 text-nowrap">{product.category?.name}</td>
                                            <td className="px-6 py-4 text-gray-800 font-semibold text-nowrap">{product.price} €</td>
                                            <td className="px-6 py-4 text-center text-nowrap">
                                                <button
                                                    className="text-blue-500 hover:text-blue-700 font-medium mr-4"
                                                    onClick={() => handleEdit(product._id)}
                                                >
                                                    Edit
                                                </button>
                                                <button
                                                    className="text-red-500 hover:text-red-700 font-medium"
                                                    onClick={() => handleDelete(product._id, product.name.en)}
                                                >
                                                    Delete
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                }
                            )
                        ) : (
                            <tr>
                                <td colSpan="5" className="px-6 py-4 text-center text-gray-500">
                                    No products found
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>

                    <div className="flex justify-center items-center mt-6 space-x-2">
                        <button
                            disabled={currentPage === 1}
                            onClick={() => handlePageChange(currentPage - 1)}
                            className={`px-3 py-1 rounded-md border ${
                                currentPage === 1
                                    ? "text-gray-400 border-gray-200"
                                    : "text-blue-600 border-blue-400 hover:bg-blue-100"
                            }`}
                        >
                            Prev
                        </button>

                        <span className="px-4">
                            Page {currentPage} of {totalPages}
                        </span>

                        <button
                            disabled={currentPage === totalPages}
                            onClick={() => handlePageChange(currentPage + 1)}
                            className={`px-3 py-1 rounded-md border ${
                                currentPage === totalPages
                                    ? "text-gray-400 border-gray-200"
                                    : "text-blue-600 border-blue-400 hover:bg-blue-100"
                            }`}
                        >
                            Next
                        </button>
                    </div>

                </div>
            </div>
            {showModalDelete && <ModalDelete setShow={setShowModalDelete} setUpdateProduct={setUpdateProduct} updateProduct={updateProduct} name={name.en} id={productID}/>}
        </div>
    );
}





export function ModalDelete({setShow, id, name, setUpdateProduct, updateProduct}) {


    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    function DeleteProduct () {

        setLoading(true)
        apiRequests.delete(`/api/product/delete-admin` , {
            data : {
                id: id
            }
        })
            .then((response) => {
                toast.success("successfully Remove product!")
                setUpdateProduct(!updateProduct)
                setShow(false)
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
            })
            .finally(() => setLoading(false));

    }

    return (

        <div className="report-modal fixed inset-0 bg-black bg-opacity-60 transition-opacity">
            <div className="flex min-h-full items-end justify-center p-3 text-center">
                <div
                    className="modal relative text-black transform overflow-hidden rounded-lg bg-white p-8 w-[30%] md:w-[90%] m-auto flex flex-col gap-5">

                    <div className=" text-gray-500">
                        Do You Want Delete This Product
                        <span className="text-firstColor-shade9 font-bold"> {name} </span>
                        ?
                    </div>

                    <div className="flex justify-center items-center gap-5 ">

                        <button className="px-4 py-1 border-2 hover:bg-red-600 hover:text-white rounded-lg border-red-600 text-red-600"
                            onClick={DeleteProduct}
                        >
                            {loading ?
                                <Loading/>
                                :
                                "Delete"
                            }
                        </button>

                        <button className="hover:bg-gray-300 border-2 px-4 py-1 rounded-lg" onClick={() => setShow(false)}>
                            Cancel
                        </button>

                    </div>
                </div>
            </div>
        </div>

    )
}